import * as types from "./types";

const mutations = {

    //#region Service Template
    [types.LOADING_SERVICEREQUESTS](state, value) {
        state.loading = value;
    },
    [types.GET_SERVICEREQUESTS_LIST](state, servicerequests) {
        state.servicerequests = servicerequests;
    },
    [types.GET_STAFFSERVICEREQUESTS_LIST](state, stafflistrequests) {
        state.stafflistrequests = stafflistrequests;
    },
    [types.REMOVE_SERVICEREQUESTS](state, id) {        
        state.servicerequests = state.servicerequests.filter((x) => x.id !== id);        
    },
    [types.APPROVE_OR_CANCEL_SERVICEREQUESTS](state, id) {        
        state.servicerequests = state.servicerequests.filter((x) => x.id !== id);        
    },
    [types.RESCHEDULE_SERVICEREQUESTS](state, id) {        
        state.servicerequests = state.servicerequests.filter((x) => x.id !== id);        
    },
    [types.ADD_SERVICEREQUESTS](state, servicerequests) {        
        state.servicerequests.unshift(servicerequests);
    },
    [types.UPDATE_SERVICEREQUESTS](state, servicerequests) {        
        const servicerequestsIndex = state.servicerequests.findIndex((x) => x.id === servicerequests.id);
        state.servicerequests[servicerequestsIndex] = servicerequests;        
    },
    [types.GET_SERVICEREQUESTSBYID](state, serviceOne) {        
        state.serviceOne = serviceOne;
    },
    [types.GET_SERVICEREQUESTSBYREFERENCENO](state, serviceOrderOne) {        
        state.serviceOrderOne = serviceOrderOne;
    },
    [types.SERVICEDOCUMENT_GET_FILE_LIST](state, id) {
        state.servicerequestDocuments = id;
    },
    [types.FILE_SHARING](state, file) {
        state.file = file;
    },
    //#endregion

    //#region Service Order
    [types.LOADING_SERVICEORDERREQUESTS](state, value) { 
        state.loading = value;
    },
    [types.GET_SERVICEORDERREQUESTS_LIST](state, serviceOrderList) {
        state.serviceOrderList = serviceOrderList;
    },
    [types.REMOVE_SERVICEORDERREQUESTS](state, id) {        
        state.serviceOrderList = state.serviceOrderList.filter((x) => x.id !== id);        
    },
    [types.ADD_SERVICEORDERREQUESTS](state, serviceOrderList) {        
        state.serviceOrderList.unshift(serviceOrderList);
    },
    [types.UPDATE_SERVICEORDERREQUESTS](state, serviceOrderList) {        
        const servicerequestsIndex = state.serviceOrderList.findIndex((x) => x.id === serviceOrderList.id);
        state.serviceOrderList[servicerequestsIndex] = serviceOrderList;        
    },
    [types.GET_SERVICEORDERREQUESTSBYID](state, serviceOrder) {        
        state.serviceOrder = serviceOrder;
    },
    [types.SERVICEORDERDOCUMENT_GET_FILE_LIST](state, id) {
        state.serviceOrderDocuments = id;
    },
    [types.SERVICEORDERDOCUMENT_LOADING_FILE](state, value) { 
        state.loading = value;
    },
    [types.SERVICEORDERDOCUMENT_ADD_FILE](state, servicerequestDocuments) {        
        state.serviceOrderDocuments.unshift(servicerequestDocuments);
    },
    //#endregion

    //#region

    [types.SERVICEORDER_GET_TIMESHEET_LIST](state, timesheetList){
        state.timesheetList = timesheetList;
    },
    [types.SERVICEORDER_TIMESHEET_LOADING](state, value){
        state.loading = value;
    },
    [types.SERVICEORDER_GET_TIMESHEET](state, timesheet){
        state.timesheet = timesheet;
    },
    [types.SERVICEORDER_ADD_TIMESHEET](state, timesheet){
        state.timesheetList.unshift(timesheet)
    },
    [types.SERVICEORDER_UPDATE_TIMESHEET](state, timesheet){
        const index = state.timesheetList.findIndex((x) => x.id === timesheet.id);
        state.timesheetList[index] = timesheet;
    },
    [types.REMOVE_ORDER_DOCUMENT](state, id) {        
        state.serviceOrderDocuments = state.serviceOrderDocuments.filter((x) => x.id !== id);        
    },

    //#endregion
};

export default mutations;